import React from 'react';
import styled from 'styled-components';

import { HermesysColors } from '../../Colors';
import { MenuButtonSize } from '../../Dimentions';
import TabbedPane from './TabbedPane';

const Container = styled.div`
  display: grid;
  height: 100%;
  grid-template-rows: 56px auto;
`;

const TopBar = styled.div`
  width: 100%;
  height: ${MenuButtonSize.height}px;
  border-bottom: solid 1px black;
  padding-left: 10px;
`;

const BottomContainer = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: 50% 50%;
  padding: 8px;
  box-sizing: border-box;
`;

const ColoredText = styled.div`
  color: ${HermesysColors.Blue};
`;

const VoicePlainText = styled.div`
  color: ${HermesysColors.VoicePlainColor};
`;

const TopHalfContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
`;

const BottomHalfContainer = styled.div`
  display: grid;
  grid-template-columns: 20% 80%;
`;

const Tag = styled.span`
  background: ${HermesysColors.ButtonBackgroundGray};
  background: rgba(179, 179, 179, 1);
  margin-right: 10px;
  padding: 2px;
  border: solid 1px rgba(109, 109, 109, 1);
  color: rgba(109, 109, 109, 1);
`;

const MenuTopContainer = styled.div`
  display: grid;
  grid-template-columns: 15% 85%;
`;

const MenuIconContainer = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-start;
  column-gap: 6px;
`;

const Icon = styled.img`
  width: 25px;
  height: 25px;
`;

const MiddleTextConsole = () => {
  return (
    <Container>
      <TopBar>
        <MenuTopContainer>
          <div>0000</div>
          <div>Main Menu</div>
        </MenuTopContainer>
        <MenuIconContainer>
          <Icon src={require('../M3SR/icons/menu.png')} />
          <div>
            <div>R: 46</div>
            <div>C: 47</div>
          </div>
          <Icon src={require('../M3SR/icons/icon1.png')} />
          <Icon src={require('../M3SR/icons/icon2.png')} />
          <Icon src={require('../M3SR/icons/icon3.png')} />
          <Icon src={require('../M3SR/icons/icon4.png')} />
          <Icon src={require('../M3SR/icons/icon5.png')} />
        </MenuIconContainer>
      </TopBar>
      <BottomContainer id="console-display-area">
        <TextConsole />
        {/* <TabbedPane /> */}
      </BottomContainer>
    </Container>
  );
};

export default MiddleTextConsole;

const TextConsole = () => {
  return (
    <>
      <TopHalfContainer>
        <div>Mode:</div>
        <ColoredText>Fixed Frequency</ColoredText>
        <div>Com Mode:</div>
        <VoicePlainText>Voice Plain</VoicePlainText>
        <div>Modulation:</div>
        <ColoredText>FM</ColoredText>
        <div>Frequency:</div>
        <ColoredText
          style={{
            fontSize: `medium`,
          }}
        >
          310 000 000 Hz
        </ColoredText>
      </TopHalfContainer>
      <BottomHalfContainer>
        <div></div>
        <div>
          <Tag>SQLM</Tag>
          <Tag>SQLG</Tag>
        </div>
        <div>Power</div>
        <div></div>
        <div>RSSI</div>
        <div></div>
        <div>VSWR</div>
        <div></div>
      </BottomHalfContainer>
    </>
  );
};
